import React, { useCallback } from "react";
import { makeStyles } from "@material-ui/core";

import {
  STOPS_SELECTED,
  X,
  CLEAR_SELECTED,
  MERGE,
  MOVE_TO,
  SAVE,
  SCHEDULE,
  SELECT_MULTIPLE,
  TRANSFER,
  OPTIMISE,
  REMOVE,
} from "../../constants/strings";
import CustomButton from "./CustomButton";
import palette from "../styles/palette";
import { Text, View } from "../Base";

const useStyles = makeStyles(({ typography }) => ({
  container: {
    display: "flex",
    margin: `${typography.pxToRem(0)} ${typography.pxToRem(
      20
    )} ${typography.pxToRem(20)} ${typography.pxToRem(30)}`,
  },
  buttonsContainer: {
    display: "flex",
    width: "calc(100% - 16.625rem)",
    flexWrap: "wrap",
  },
  stopsInfo: {
    height: typography.pxToRem(30),
    borderRadius: 4,
    marginLeft: "auto",
    display: "flex",
    alignItems: "center",
    alignSelf: "flex-end",
    justifyContent: "center",
    width: typography.pxToRem(183),
    background: palette.typography.black.disabled,
  },
  stopInfoTitle: {
    fontWeight: 500,
    fontSize: typography.pxToRem(16),
    color: palette.typography.white.solid,
  },
  stopInfoSeparator: {
    margin: typography.pxToRem(10),
    fontSize: typography.pxToRem(12),
    color: palette.typography.white.medium,
  },
}));

const BottomOptions = ({
  selectedStops,
  isParcelDetails,
  isScheduleRequired,
  isRouteReadyOrOpen,
  clearSelection,
  onSelectMultipleClick,
  onMoveToClick,
  onMergeClick,
  onScheduleClick,
  onOptimiseClick,
  onSaveClick,
  onTransferClick,
  isMoveToDisabled,
  isTransferDisabled,
  isMergeDisabled,
  isSaveRouteEnabled,
  onRemoveClick,
  isRemoveDisable,
}) => {
  const classes = useStyles();
  const isSelectedStop = !!selectedStops.length;
  const transfer = useCallback(() => {
    onTransferClick(true);
  }, [onTransferClick]);

  return (
    <View className={classes.container}>
      <View className={classes.buttonsContainer}>
        <View className={classes.optionsButtons}>
          {isSelectedStop ? (
            <CustomButton
              leftButton
              title={CLEAR_SELECTED}
              onClick={clearSelection}
            />
          ) : (
            <CustomButton
              leftButton
              title={SELECT_MULTIPLE}
              onClick={onSelectMultipleClick}
            />
          )}
          <CustomButton
            leftButton
            title={MOVE_TO}
            onClick={onMoveToClick}
            disabled={isMoveToDisabled}
          />
          <CustomButton
            leftButton
            title={MERGE}
            onClick={onMergeClick}
            disabled={isMergeDisabled}
          />
          {isRouteReadyOrOpen && (
            <CustomButton
              leftButton
              title={OPTIMISE}
              onClick={onOptimiseClick}
            />
          )}
          <CustomButton
            leftButton
            title={SCHEDULE}
            onClick={onScheduleClick}
            disabled={!isScheduleRequired}
          />
          <CustomButton
            leftButton
            title={SAVE}
            onClick={onSaveClick}
            disabled={!isSaveRouteEnabled}
          />
          <CustomButton
            leftButton
            title={TRANSFER}
            onClick={transfer}
            disabled={isTransferDisabled}
          />
          <CustomButton
            leftButton
            title={REMOVE}
            onClick={onRemoveClick}
            disabled={isRemoveDisable}
          />
        </View>
      </View>
      {!isParcelDetails && selectedStops.length > 0 && (
        <span className={classes.stopsInfo}>
          <Text noWrap className={classes.stopInfoTitle}>
            {selectedStops.length}
          </Text>
          <Text noWrap className={classes.stopInfoSeparator}>
            {X}
          </Text>
          <Text noWrap className={classes.stopInfoTitle}>
            {STOPS_SELECTED}
          </Text>
        </span>
      )}
    </View>
  );
};

export default React.memo(BottomOptions);
